module.exports = __webpack_public_path__ + "static/media/westinchennai08.de43218b.jpg";